<template>
    <shinsei-type-list />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import ShinseiTypeList from '@/components/shinsei/TypeList.vue';

export default defineComponent({
    setup() {
      return {}
    },
    components: {
      'shinsei-type-list': ShinseiTypeList
    }
})
</script>
